import React from 'react';
import { actionTypes, documentStatuses, documentBpActions as bpActions, formFieldTypes, docTypes, formModes } from '../../constants';
import { renderAttachments, renderFormHeader, renderMainContract, renderMainFile, renderAdditionalCounterparties } from '../document/DocumentHelpers';
import { formatFloatTextValue, changeInputValue } from '../helpers/HelperFunctions';
import { contractTypes } from './forwarderContract';
import i18next from "../../i18n";
import { Table } from '../table/Table';
import MutualSettlementDataField from '../form/MutualSettlementDataField';

export const statuses = Object.assign(documentStatuses, {
    sendingCofco: "Sending Cofco", //Відправка документа COFCO
    refinementCofco: "Refinement Cofco", //На доопрацюванні COFCO
    familiarizationCounterparty: "Familiarization Counterparty", //На ознайомленні контрагентом
    signingCofco: "SigningCofco", //На підписанні COFCO
    agreementCofco: "AgreementCofco", //На узгодженні COFCO
    canceledCofco: "CanceledCofco", //Скасовано COFCO
});
export const outgoingDocumentKinds = {
    account: "4", //Рахунок
    salesInvoice: "5", //Видаткова накладна
    actOfCompletedWorks: "6", //Акт виконаних робіт
    reconciliationAct: "reconciliationAct", //Акт звірки
    mutualSettlementsAct: "mutualSettlementsAct", //Акт звірки взаєморозрахунків
}
export const settings = {
    statuses: statuses,
    actions: [
        {
            title: i18next.t("sendTo"),
            btnClass: "btn-secondary",
            action: bpActions.approve,
            type: actionTypes.save,
            statuses: [statuses.performingCounterparty, statuses.processingCounterparty, statuses.signingCounterparty, statuses.additionalSigningCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("sendTo"),
            btnClass: "btn-secondary",
            action: bpActions.approve,
            type: actionTypes.save,
            statuses: [statuses.refinementCounterparty],
            kinds: [outgoingDocumentKinds.mutualSettlementsAct]
        },
        {
            title: i18next.t("confirm"),
            btnClass: "btn-primary",
            action: bpActions.approve,
            type: actionTypes.save,
            statuses: [statuses.familiarizationCounterparty, statuses.refinementCounterparty],
            excludedKinds: [outgoingDocumentKinds.mutualSettlementsAct]
        },
        {
            title: i18next.t("signOrElectronicSeal"),
            btnClass: "btn-primary",
            type: actionTypes.sign,
            statuses: [statuses.signingCounterparty, statuses.additionalSigningCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("signOrElectronicSeal"),
            btnClass: "btn-primary",
            type: actionTypes.sign,
            statuses: [statuses.refinementCounterparty, statuses.performingCounterparty],
            kinds: [outgoingDocumentKinds.mutualSettlementsAct]
        },
        {
            title: i18next.t("forAdditionalSigning"),
            btnClass: "btn-secondary",
            action: bpActions.additionalSigning,
            type: actionTypes.additionalSign,
            statuses: [statuses.signingCounterparty, statuses.signingCounterpartyMD]
        },
        {
            title: i18next.t("forAdditionalSigning"),
            btnClass: "btn-secondary",
            action: bpActions.additionalSigning,
            type: actionTypes.additionalSign,
            statuses: [statuses.refinementCounterparty, statuses.performingCounterparty],
            kinds: [outgoingDocumentKinds.mutualSettlementsAct]
        },
        {
            title: i18next.t("forRevision"),
            btnClass: "btn-secondary",
            action: bpActions.refinement,
            type: actionTypes.save,
            statuses: [statuses.signingCounterparty, statuses.processingCounterparty, statuses.refinementCounterparty, statuses.signingCounterpartyMD],
            excludedKinds: [outgoingDocumentKinds.mutualSettlementsAct]
        },
        {
            title: i18next.t("edit"),
            btnClass: "btn-secondary",
            type: actionTypes.edit,
            statuses: [statuses.performingCounterparty, statuses.processingCounterparty, statuses.refinementCounterparty]
        },
        {
            title: i18next.t("reject"),
            btnClass: "btn-secondary",
            action: bpActions.reject,
            type: actionTypes.reject,
            statuses: [statuses.performingCounterparty, statuses.additionalSigningCounterparty, statuses.refinementCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("cancel"),
            btnClass: "btn-secondary",
            action: bpActions.annul,
            type: actionTypes.annul,
            statuses: [statuses.signedCounterparty, statuses.preparationCounterparty, statuses.processingCounterparty],
            modes: [formModes.read]
        }
    ]
}
const prop_sxcfc_priceWithPDVIsVisible = (prop_sx_docKind) => [outgoingDocumentKinds.account, outgoingDocumentKinds.actOfCompletedWorks, outgoingDocumentKinds.salesInvoice].includes(prop_sx_docKind ? prop_sx_docKind : "");
const reconciliationActHidden = ["prop_sx_docKind", "prop_sx_regNumber", "empty", "prop_sxcfc_priceWithPDV"];
const notReconciliationActHidden = ["empty2", "prop_sxcfc_productType", "prop_sxcfc_harvestYear", "prop_sxcfc_reconciliationDate", "elevatorData", "prop_sxcfc_storageData"];
export function checkInputPage() {
    this.mutualSettlementDataError = false;
    this.checkErrorText = '';
    const { prop_sx_docKind, prop_sxcfc_acceptedProducts, prop_sxcfc_shippedProducts, prop_sxcfc_writtenOffProducts, prop_sxcfc_storageData, prop_sxcfc_reconciliationDate } = this.state;
    if (prop_sx_docKind === outgoingDocumentKinds.reconciliationAct) {
        return prop_sxcfc_acceptedProducts && prop_sxcfc_shippedProducts && prop_sxcfc_writtenOffProducts && prop_sxcfc_storageData && prop_sxcfc_reconciliationDate;
    }
    else if (prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct) {
        const { mutualSettlementData } = this.state;
        if (!mutualSettlementData || !mutualSettlementData.data) {
            this.checkErrorText = i18next.t("mutualSettlementData.checkMessages.emptyData");
            this.mutualSettlementDataError = true;
            return false;
        }
        else {
            const notEmptyItems = mutualSettlementData.data.filter(item => item.counterpartyItem?.document || item.counterpartyItem?.date || item.counterpartyItem?.debit || item.counterpartyItem?.credit);
            if (notEmptyItems.length === 0) {
                this.checkErrorText = i18next.t("mutualSettlementData.checkMessages.emptyData");
                this.mutualSettlementDataError = true;
                return false;
            }
            if (mutualSettlementData.counterpartyDebitSaldo && mutualSettlementData.counterpartyCreditSaldo) {
                this.checkErrorText = i18next.t("mutualSettlementData.checkMessages.hasIncorrectDebitCreditSaldo");
                this.mutualSettlementDataError = true;
                return false;
            }
            let errorItems = notEmptyItems.filter(item => !item.counterpartyItem?.document || !item.counterpartyItem.date || (!item.counterpartyItem.debit && !item.counterpartyItem.credit));
            if (errorItems.length > 0) {
                this.checkErrorText = i18next.t("mutualSettlementData.checkMessages.notAllDataFilled");
                this.mutualSettlementDataError = true;
                return false;
            }
            else {
                errorItems = notEmptyItems.filter(item => item.counterpartyItem.debit && item.counterpartyItem.credit);
                if (errorItems.length > 0) {
                    this.checkErrorText = i18next.t("mutualSettlementData.checkMessages.hasIncorrectDebitCreditData");
                    this.mutualSettlementDataError = true;
                    return false;
                }
            }
        }
    }
    return true;
}
export function buildFormItem(item) {
    const { prop_sx_docKind } = this.state;

    if (item.Name === 'prop_sxcfc_remark') {
        return;
    }

    if (item.Name === 'prop_sx_dateFrom' || item.Name === 'prop_sx_dateTo') {
        if (prop_sx_docKind !== outgoingDocumentKinds.mutualSettlementsAct) {
            return;
        }
    }

    if (prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct) {
        if (item.Name === 'prop_sx_regDate' || item.Name === 'prop_sx_contents' || item.Name === 'empty') {
            return;
        }
        if (item.Name === 'prop_sx_docKind' || item.Name === 'prop_sx_regNumber') {
            item.Required = false;
        }
    }

    if ("prop_sxcfc_priceWithPDV" === item.Name && !prop_sxcfc_priceWithPDVIsVisible(prop_sx_docKind)) {
        return;
    }
    else if (prop_sx_docKind === outgoingDocumentKinds.reconciliationAct && reconciliationActHidden.includes(item.Name)) {
        return;
    }
    else if (prop_sx_docKind !== outgoingDocumentKinds.reconciliationAct && notReconciliationActHidden.includes(item.Name)) {
        return;
    }
    else {
        if (prop_sx_docKind === outgoingDocumentKinds.reconciliationAct && item.Name === "prop_sx_regDate") {
            item.Label.Label = i18next.t("reconciliationActRegLabel");
            item.Required = false;
            item.Disabled = true;
        }
        if (prop_sx_docKind === outgoingDocumentKinds.reconciliationAct && item.Name === "prop_sx_contents") {
            item.Required = false;
            item.Disabled = true;
        }
        if (item.Type === formFieldTypes.elevatorData) {
            const { prop_sxcfc_acceptedProducts, prop_sxcfc_shippedProducts, prop_sxcfc_writtenOffProducts } = this.state;
            item.Value = {
                intake: prop_sxcfc_acceptedProducts,
                outtake: prop_sxcfc_shippedProducts,
                shrink: prop_sxcfc_writtenOffProducts
            }
        }
        return item;
    }
}

export function renderinformation() {
    const { prop_sx_docKind, prop_sx_documentType } = this.state;
    return (
        <div key="informationTab">
            <div className="doc-form-block" key="informationTabBlock">
                {renderFormHeader.bind(this)()}
                {renderAdditionalCounterparties.bind(this)()}
                <div className="form-block large-form doc-form doc-form__creat">
                    <div className="form-content">
                        <div className="row">
                            {this.buildFormSection("mainForm")}
                            {prop_sx_docKind !== outgoingDocumentKinds.mutualSettlementsAct && (docTypes.contract === prop_sx_documentType ? ((prop_sx_docKind === contractTypes.Additional || prop_sx_docKind === contractTypes.Protocol) ? renderMainContract.bind(this)({ "DocType": docTypes.contract, "Status": [statuses.valid] }) : "") : renderMainContract.bind(this)({ "DocType": docTypes.contract, "Status": [statuses.valid] }))}
                            {prop_sx_docKind !== outgoingDocumentKinds.reconciliationAct && renderAttachments.bind(this)()}
                            {prop_sx_docKind === outgoingDocumentKinds.reconciliationAct && renderElevatorPhysicalChecks.bind(this)()}
                            {prop_sx_docKind === outgoingDocumentKinds.reconciliationAct && renderElevatorTechnicalConditions.bind(this)()}
                        </div>
                    </div>
                    {prop_sx_docKind === outgoingDocumentKinds.mutualSettlementsAct && renderMutualSettlements.bind(this)()}
                    <div className="col-lg-12">
                        <div className="required-label"><label className="required"></label>{i18next.t("requiredFields")}</div>
                    </div>
                </div>
            </div>
            {renderMainFile.bind(this)()}
        </div>
    )
}

function renderElevatorPhysicalChecks() {
    const { elevatorPhysicalChecks } = this.state;
    if (elevatorPhysicalChecks && elevatorPhysicalChecks.length > 0) {
        const columns = [
            {
                "id": "0",
                "name": "SilosNumber",
                "CanSort": true,
                "headerName": i18next.t("elevatorSilosNumberLabel"),
                "type": "string"
            },
            {
                "id": "1",
                "name": "ElevatorWeight",
                "CanSort": true,
                "headerName": i18next.t("elevatorWeightLabel"),
                "type": "string"
            }
        ]

        let rows = [];
        elevatorPhysicalChecks.forEach(item => {
            rows.push({
                columns: {
                    Id: item.id,
                    SilosNumber: item.numberSilo,
                    ElevatorWeight: formatFloatTextValue(item.tonnage)
                }
            })
        });

        rows = rows.sort((el1, el2) => { return parseFloat(el1.columns.SilosNumber) > parseFloat(el2.columns.SilosNumber) ? 1 : -1 });

        return (<div className="col-lg-12">
            <label className="table-label">{i18next.t("elevatorPhysicalChecks")}</label>
            <div>
                <div className="table-block">
                    <Table key="ElevatorPhysicalChecks" disableSelection={true} columns={columns} items={rows} sortBy="Title" isDesk={false} />
                </div>
            </div>
        </div>);
    }
    return "";
}
function renderElevatorTechnicalConditions() {
    const { elevatorTechnicalConditions } = this.state;
    if (elevatorTechnicalConditions && elevatorTechnicalConditions.length > 0) {
        const columns = [
            {
                "id": "0",
                "name": "ElevatorTechnicalState",
                "CanSort": false,
                "headerName": i18next.t("elevatorTechnicalStateLabel"),
                "type": "string"
            },
            {
                "id": "1",
                "name": "SilosNumber",
                "CanSort": false,
                "headerName": i18next.t("elevatorSilosNumberLabel"),
                "type": "string"
            }
        ]

        let rows = [];
        elevatorTechnicalConditions.forEach(item => {
            rows.push({
                columns: {
                    Id: item.id,
                    SilosNumber: item.numberSilo,
                    ElevatorTechnicalState: item.elevatorInspectionResults
                }
            });
        });
        rows = rows.sort((el1, el2) => { return parseFloat(el1.columns.SilosNumber) > parseFloat(el2.columns.SilosNumber) ? 1 : -1 });

        return (<div className="col-lg-12">
            <label className="table-label">{i18next.t("elevatorTechnicalConditions")}</label>
            <div>
                <div className="table-block">
                    <Table key="ElevatorTechnicalConditions" disableSelection={true} columns={columns} items={rows} sortBy="Title" isDesk={false} />
                </div>
            </div>
        </div>);
    }
    return "";
}

function onMutualSettlementDataChanged(data) {
    this.setState({ mutualSettlementData: data });
}

function renderMutualSettlements() {
    return (<div className="col-lg-12">
        <label className="table-label">{i18next.t("mutualSettlementLabel")}</label>
        <div>
            <MutualSettlementDataField docId={this.state.prop_sys_node_uuid} formMode={this.state.formMode} onChange={onMutualSettlementDataChanged.bind(this)} comment={this.state.prop_sxcfc_remark} cashedData={this.state.mutualSettlementCashedData} onCommentChanged={changeInputValue.bind(this)} />
        </div>
    </div>);
}
